import { PickingStatus } from "@quickcommerceltd/zephyr-types";

export const TASK_PICKING_STATUSES: PickingStatus[] = [
  "WAITING",
  "PICKING",
  "PACKED",
];
